import type { GetListParams } from "ra-core";

/**
 * Tri de la liste des projets : un tri sur le score passe par `score_rank`
 * (score, puis note avant plafond au millième), pour départager les fiches
 * plafonnées à la même valeur. Le score affiché ne change pas.
 *
 * Tout tri finit par `id` : sans second critère, Postgres rend les ex aequo
 * dans un ordre qui change d'une page à l'autre ; une fiche revenait sur deux
 * pages et une autre n'apparaissait jamais, et les cartes en double restaient
 * affichées au changement de pays sur téléphone (26/10/2026). Le fournisseur
 * PostgREST ne connaît qu'un champ : le premier est écrit avec son sens
 * (celui de `sortOrder` dans dataProvider.ts), il ajoute celui de `id`.
 */
export const withScoreRank = (params: GetListParams): GetListParams => {
  const { sort } = params;
  if (!sort?.field || sort.field === "id") return params;
  const column = sort.field === "score" ? "score_rank" : sort.field;
  const direction = sort.order === "ASC" ? "asc" : "desc.nullslast";
  return { ...params, sort: { ...sort, field: `${column}.${direction},id` } };
};
